import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IMeasurement } from 'types';

interface InitialState {
  list: IMeasurement[];
}

const initialState: InitialState = {
  list: [],
};

const slice = createSlice({
  name: 'measurements',
  initialState,
  reducers: {
    setMeasurements: (state, action: PayloadAction<IMeasurement[]>) => {
      state.list = [...action.payload];
    },
  },
});

export const {
  reducer,
  actions: { setMeasurements },
} = slice;
